/**
 * Created by koqiui on 2017-04-12.
 */
import api from './index'

//缓存当前用户上下文信息
let cachedUserResult = null;
//
let exports = {};

exports.doUserLogin = function (params, callback) {// 登录
    api.post('/user/login/do')
    .data(params)
    .done(callback)
    .go();
};
//

exports.doUserRegist = function (params, callback) {// 注册会员
    api.post('/user/regist/do')
    .data(params)
    .done(callback)
    .go();
};
exports.resetLogPass = function (params, callback) {// 短信重置登录密码（兼容 已登录和未登录）
    api.post('/user/logPass/reset/do')
    .data(params)
    .done(callback)
    .go();
};
exports.changeUserPhoneNo = function (data, callback) {// 修改用户账号(已登录)
    api.post('/user/phoneNo/change/do')
    .data(data)
    .done(callback)
    .go();
};
exports.getMerchantList = function (params, callback) {// 返回当前用户所有入口选择列表
    api.post('/user/pc/merchant/list/get')
    .data(params)
    .done(callback)
    .go();
};
exports.getPcEntryList = function (params, callback) {// 返回当前用户所有入口选择列表
    api.post('/user/pc/entry/list/get')
    .data(params)
    .done(callback)
    .go();
};
exports.getEntryList = function (params, callback) {// 返回当前用户所有入口选择列表
    api.post('/user/entry/list/get')
    .data(params)
    .done(callback)
    .go();
};
exports.getEntryTarget = function (params, callback) {// 返回当前用户选择的入口url
    api.post('/user/entry/target/get')
    .data(params)
    .done(callback)
    .go();
};
exports.doUserLogout = function (params, callback) {// 注销操作
    api.get('/user/logout/do')
    .data(params)
    .done(callback)
    .go();
};

exports.getScopeEntityVipLevel = function () {
    let ctxVipLevel = 0;
    exports.getUserInfoByContext({}, function (result, jqXhr) {
        let scopeEntity = result.data.scopeEntity;
        ctxVipLevel = scopeEntity.vipLevel;
    });
    return ctxVipLevel;
};

//
exports.getUserInfoByContext = function (params, callback) {// 返回当前用户信息
    if(cachedUserResult == null) {
        api.post('/user/info/get/by/context')
        .sync(true)
        .data(params)
        .done(function (result) {
            if(result.type == 'info') {
                cachedUserResult = result;
                let userContext = result.data || {};
                cachedUserResult.data = userContext;
                //处理nickName缺失问题
                userContext.nickName = userContext.nickName || userContext.userName;
                //给scopeEntity 增加额外方法
                let scopeEntity = userContext.scopeEntity || {};
                userContext.scopeEntity = scopeEntity;
                //
                scopeEntity.getComId = function (level) {
                    level = level || "";
                    return this["comId" + level] || null;
                };
            }
            //
            if(typeof callback == 'function') {
                callback(result);
            }
        })
        .go();
    }
    else {
        if(typeof callback == 'function') {
            callback(cachedUserResult);
        }
    }
};

exports.getUserByContext = function (params, callback) {// 获取当前用户(根据上下文获取)
    api.post('/user/get/by/context')
    .data(params)
    .done(callback)
    .go();
};
exports.updateUser = function (params, callback) {// 修改用户
    api.post('/user/update/do')
    .data(params)
    .done(callback)
    .go();
};
exports.updateUserPswd = function (params, callback) {// 修改用户密码(已登录)
    api.post('/user/pswd/update/do')
    .data(params)
    .done(callback)
    .go();
};

exports.doResetPassword = function (params, callback) {// 商户对员工密码修改
    api.post('/user/password/update/do')
    .data(params)
    .done(callback)
    .go();
};

// 获取菜单频道列表
exports.getSysMenuChnlList = function (params, callback) {// 通过上下文获取菜单频道
    api.post('/user/sys/menu/chnl/list/get')
    .data(params)
    .done(callback)
    .go();
};
// 获取菜单列表
exports.getSysMenusList = function (params, callback) {// 通过上下文获取菜单资源
    api.post('/user/sys/menu/list/get')
    .data(params)
    .done(callback)
    .go();
};

//获取上下文用户的岗位资源列表
exports.getUserPostRescListByContext = function (params, callback) {
    api.post('/user/post/resc/list/get/by/context')
    .sync(true)
    .data(params)
    .done(callback)
    .fail(callback)
    .go();
};
//获取上下文用户的岗位资源列表
exports.getfuncMapInfoByCode = function (params, callback) {
    api.post('/user/func/map/Info/get/by/code')
    .sync(true)
    .data(params)
    .done(callback)
    .fail(callback)
    .go();
};

//自动登录
exports.getAutoLoginEntry = function (params, callback) {
    api.post('/user/mini/auto/entry/get')
    .sync(true)
    .data(params)
    .done(callback)
    .fail(callback)
    .go();
};


export default exports;



//////////////////
// WEBPACK FOOTER
// ./src/api/user.js
// module id = 5
// module chunks = 1